import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobAcknowledgementComponent } from './job-acknowledgement.component';
import { StaticDataLookupModule } from 'shared/components/lookup/static-data-lookup/static-data-lookup.module';


@NgModule({
    imports: [
        CommonModule,
        NgbModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        StaticDataLookupModule,

    ],
    declarations: [JobAcknowledgementComponent],
    exports: [JobAcknowledgementComponent],
})
export class JobAcknowledgementModule { }
